export * from './ubiSlimScroll.directive';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/directives/ubiSlimScroll/index.ts